import * as React from 'react';
import { Button, IconLocation16, Responsive } from '@cian/ui-kit';

import * as styles from './PageHeader.css';

interface IPageHeaderProps {
  title: string;
  locationName: string;
  onLocationButtonClick: () => void;
}

export const PageHeader: React.FC<IPageHeaderProps> = ({ title, locationName, onLocationButtonClick }) => {
  return (
    <div className={styles['container']} data-name="PageHeader">
      <h1 className={styles['title']}>{title}</h1>
      <Responsive desktop>
        <Button
          beforeIcon={<IconLocation16 color="primary_100" />}
          theme="fill_white_primary"
          onClick={onLocationButtonClick}
        >
          {locationName}
        </Button>
      </Responsive>
    </div>
  );
};
